import { Component, Input } from '@angular/core';
import { CustomButtonComponent } from "../../components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-delete-confirmation-dialog',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe, CommonModule],
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrl: './delete-confirmation-dialog.component.css'
})
export class DeleteConfirmationDialogComponent {
  @Input() modalDialogId: string = 'delete_confirmation_dialog';
  private dialogResponsePromise!: (value: boolean) => void;

  @Input() title: string = '';
  @Input() body: string = '';
  @Input() confirmButtonText: string | null = null;
  @Input() denyButtonText: string | null = null;
  @Input() showBinIcon: boolean = true;

  openModal(): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
    }

    return Promise.resolve(false);
  }

  closeModal(dialogResponse: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
      this.dialogResponsePromise(dialogResponse);
    }
  }
}
